export const SPECIAL_ROUTES = {
  ACCOUNT_ORDERS: '/account/orders',
  ACCOUNT_PROFILE: '/account/profile',
  PROFILE_SETTINGS: '/account/profile/settings',
  PROFILE_PASSWORD: '/account/profile/password',
  COMPANY_ORDERS: '/company/orders',
  CART: '/cart',
  CHECKOUT: '/checkout',
  DELIVERY: '/delivery',
  ALL_SWAG: '/collections/all-swag',
  PRODUCT: '/product',
  COLLECTIONS: '/collections',
  PRIVACY_POLICY: '/privacy-policy',
  TOS: '/terms-of-service',
  SIZE_SUBMISSIONS: '/account/size-submissions'
};